import { render, staticRenderFns } from "./ShopBindAccount.vue?vue&type=template&id=755157f6&scoped=true"
import script from "./ShopBindAccount.vue?vue&type=script&lang=js"
export * from "./ShopBindAccount.vue?vue&type=script&lang=js"
import style0 from "./ShopBindAccount.vue?vue&type=style&index=0&id=755157f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755157f6",
  null
  
)

export default component.exports